import React, { Component } from 'react';
import { registryCombineReducer } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/combineRegistry';
import TaskCreate from './TaskCreate';

import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

class TasksCreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `createTaskForm`
    };
    registryCombineReducer(this.state.reducerName);
  }

  render() {
    return <TaskCreate reducerName={this.state.reducerName} />;
  }
}

TasksCreateForm.defaultProps = {};

export default ColumnsContent(TasksCreateForm);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskCreate/index.js